import { intersectionWatcher, delayOffset } from "@/lib/animation";

const selectors = {
  headerItems: ".animation--section-introduction > *",
  animationItem: ".animation--item",
};

export default node => {
  delayOffset(node, [selectors.headerItems, selectors.animationItem]);

  const observer = intersectionWatcher(node, true);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
